import { keyPathMirror } from 'key-path-mirror';

import { LocalesKey } from '../localesKeysTypes';

interface SourceFilesKeyType {
  downloadPlural: LocalesKey;
  plural: LocalesKey;
  pluralLowerCase: LocalesKey;
  uploadPlural: LocalesKey;
  uploadSource: LocalesKey;
}

export const sourceFilesKeys = keyPathMirror<SourceFilesKeyType, string>(
  {
    downloadPlural: null,
    pluralLowerCase: null,
    plural: null,
    uploadPlural: null,
    uploadSource: null
  },
  'models.sourceFiles.'
);
